module.exports = __webpack_public_path__ + "static/media/feeding.6b0d9c6e.jpg";